module.exports = {"230723100":"乌伊岭镇","230723101":"汤旺河镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230723.json
// module id = 849
// module chunks = 0